import { api } from "services"

export async function getActions() {
  const { data } = await api.get("/permissions/actions")
  
  return data
}
